import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SeoMetadataService } from '@uc/utilities';
import { Product } from '@uc/web/shared/data-models';

@Injectable({ providedIn: 'root' })
export class CourseService {
	private _router = inject(Router);
	private _seoSrv = inject(SeoMetadataService);

	isInvalidCourse(errorCode: any): boolean {
		if (errorCode === 'INVALID_COURSE') {
			this._router.navigate(['/404']);
			return true;
		}
		return false;
	}

	handleCourseError(status: any): void {
		if (status === 404) {
			const url = this._router.url.replace('clearing', 'undergraduate');
			this._router.navigateByUrl(url);
		}
	}

	updateSeoMetadata(courseName: string, universityName: string): void {
		this._seoSrv.updateTitle(`${courseName} | ${universityName}`);
		this._seoSrv.updateDescription(
			`See information about ${courseName} course at ${universityName}, including; course info tuition fees, living costs, entry requirements, graduate salary and more.`,
		);
	}

	getCourseSearchBannerDesc(uniName: string, product: Product) {
		if (product === 'postgraduate') {
			return `Take the next steps at ${uniName} with our postgraduate course search.`;
		}
		return `Find more courses from ${uniName}  with our undergraduate course search.`;
	}
}
